<!-- UNIVAPLAT-3518: link contract admins modal (role/aria-modal/focus trap come from NgbModal) -->
<div class="modal-header">
    <h1 class="modal-title fs-5 fw-normal" id="link-contract-admins-title" data-testid="link-admins-title">Link contract admins</h1>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"
            data-testid="link-admins-close"></button>
</div>
<div class="modal-body">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="alert alert-warning mb-0" role="alert" data-testid="link-admins-error">{{ loadError }}</div>
    } @else if (candidates.length === 0) {
        <p class="text-muted mb-0" data-testid="link-admins-empty">No contract admin users available to link</p>
    } @else {
        <div class="table-responsive">
            <table class="table table-sm align-middle" data-testid="link-admins-table">
                <caption class="visually-hidden">Users that can be linked as contract admins</caption>
                <thead>
                    <tr>
                        <th scope="col"><span class="visually-hidden">Select</span></th>
                        <th scope="col">First name</th>
                        <th scope="col">Last name</th>
                        <th scope="col">Email</th>
                    </tr>
                </thead>
                <tbody>
                    @for (user of candidates; track user.id) {
                        <tr data-testid="link-admins-row">
                            <td>
                                <input type="checkbox" class="form-check-input"
                                       [attr.aria-label]="userName(user)"
                                       [checked]="isSelected(user)"
                                       [disabled]="saving"
                                       (change)="toggle(user, $any($event.target).checked)"
                                       data-testid="link-admins-checkbox">
                            </td>
                            <td>{{ user.firstName }}</td>
                            <td>{{ user.lastName }}</td>
                            <td>{{ user.email }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-gray text-dark" (click)="modal.dismiss(false)"
            data-testid="link-admins-cancel">Cancel</button>
    <button type="button" class="btn btn-success"
            [disabled]="saving || loading || selectedCount === 0"
            (click)="submit()"
            data-testid="link-admins-submit">
        Add selected to contract
    </button>
</div>
